import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {HashMap, TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-coverage-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  templateUrl: './coverage-section.component.html',
})
export class CoverageSectionComponent {
  readonly titleKey = input.required<string>();
  readonly titleParams = input<HashMap>({});
  readonly subtitleKey = input('');
}
